import styled, { keyframes } from 'styled-components';

const cursorBlinkEffect = keyframes`
    50% { border-color: transparent; }
`;

export const AutoTypeText = styled.p`
    display: inline-block;
    border-right: 0.1em solid black;
    font-weight: normal;
    font-size: 14px;
    white-space: nowrap;
    color: ${props => props.theme.colors.charcoal40};
    position: absolute;
    top: 10px;
    left: 15px;
    overflow: hidden;
    pointer-events: none;
    animation: ${cursorBlinkEffect} 0.5s step-end infinite alternate;
`;
